export default __webpack_public_path__ + "static/media/send-icon.e2ade0a5.svg";